<template>
    <section class="mobile_wrap">
        <div class="menu_wrap">
            <div class="menu_img">
                <img class="logo" src="@/assets/img/event/logo.png"/>
            </div>
            <div class="bg_flt">
                <img src="@/assets/img/result/bg_float.png" />
            </div>
            <div class="swiper_wrap" id="menu_list">
                <swiper
                    :modules="modules"
                    :slides-per-view="5"
                    :space-between="80"
                    :autoplay="true" 
                    :speed="500" 
                    class="menu_01"
                >
                    <swiper-slide v-for="item in menu1" :key="item">
                        <div class="img_wrap">
                            <img :src="require(`@/assets/img/result/${item}.jpg`)" />
                        </div>
                    </swiper-slide>
                </swiper>
                <swiper
                    :modules="modules"
                    :slides-per-view="5"
                    :space-between="80"
                    :autoplay="true" 
                    :speed="500" 
                    class="menu_02"
                >
                    <swiper-slide v-for="item in menu2" :key="item">
                        <div class="img_wrap">
                            <img :src="require(`@/assets/img/result/${item}.jpg`)" />
                        </div>
                    </swiper-slide>
                </swiper> 
                <swiper
                    :modules="modules"
                    :slides-per-view="5"
                    :space-between="80"
                    :autoplay="true" 
                    :speed="500" 
                    class="menu_03"
                >
                    <swiper-slide v-for="item in menu3" :key="item">
                        <div class="img_wrap">
                            <img :src="require(`@/assets/img/result/${item}.jpg`)" />
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="txt_wrap">
                <img class="tlt" src="@/assets/img/result/tlt_2.png" />
                <img class="txt" src="@/assets/img/result/txt_02.png" />
            </div>
            <button class="app_link" @click="handleLinkClick">앱으로보기</button>
        </div>
    </section>
</template>

<script>
import { useRoute } from 'vue-router';
import  {  Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay } from "swiper";
import 'swiper/css';

export default {
    name : "RecMenuResult",
    el : "#menu_list",
    components : {
        Swiper,
        SwiperSlide,
    },
    data : function() {
        const route = useRoute();

        return {
            modules : [Autoplay],
            menu1 :  [
                '57568', '58624', '59543', '61288', '66751', '70022', '74809', '74974', '76864', '79194'
            ],
            menu2 : [
                '86261', '116651', '117060', '117829', '119341', '121553', '121853', '121936', '128472', '129791'
            ],
            menu3 : [
                '134221', '135976', '139386', '139397', '139410', '140007', '140110', '141381','79926', '83809'
            ]
        }
    },
    methods : {
       handleLinkClick : function() { 
        window.open('https://todaymeal.page.link/download', '_blank');
       }
    }
}
</script>

<style lang="scss" scoped>
.mobile_wrap {
    position:relative;
    overflow:hidden;
}
.menu_wrap {
    position:relative;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    background:url("../../src/assets/img/event/bg.jpg") 0 0 no-repeat;
    background-size:cover;
    overflow:hidden;
}
.menu_img {
    position:relative;
    top: 9.5%;
    width:100vw;
    height:45vw;
    .logo{   
        position: absolute;
        top: 12.5%;
        left: 50%;
        width: 40vw;
        transform: translate(-50%, 0);
    }
}
.bg_flt {
    position:relative;
    top:16.6667vw;
    width:95vw;
    left:50%;
    transform:translateX(-50%);
    img {
        width:100%;
    }
}
#menu_list {
    position:relative;
    top:-65.8333vw;
    left:0;
    width:100%;
    height:125.0000vw;
    .menu_01 {
        top: 3.8889vw;
        width: 100%;
        height: 32.7778vw;
    }
    .menu_02 {
        top: 14.1667vw;
        width: 100%;
        height: 32.7778vw;
    }
    .menu_03 {
        top:22.5000vw;
        width: 100%;
        height: 32.7778vw;
    }

    .img_wrap {
        position:relative;
        top:0;
        left:0;
        width:22.2222vw;
        height:33.3333vw;
        opacity:0.85;
        img{
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%, -50%);
            width:100%;
        }
    }
    
}
.txt_wrap {
    z-index:10;
    position:absolute;
    top:35%;
    left:50%;
    transform:translateX(-50%);
    .tlt {
        position:absolute;
        left:50%;
        transform:translateX(-50%);
        width:44.4444vw;
    }
    .txt{
        position:absolute;
        top:20.0000vw;
        left:50%;
        transform:translateX(-50%);
        width:69.4444vw;
    }
}
.app_link {
    z-index:10;
    position:absolute;
    top: 70%;
    left:50%;
    transform:translateX(-50%);
    width:48.1944vw;
    height:13.0556vw;
    text-indent:-2777.5000vw;
    background:url("../../src/assets/img/event/btn_moveapp.png") 0 0 no-repeat;
    background-size: contain;
    border:0;
}
</style>